import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ILottoEventDto from '@core/mappers/lotto/dtos/ILottoEventDto';
import LottoEvent from '@core/models/lotto/LottoEvent';
import LottoOddMapper from '@core/mappers/lotto/LottoOddMapper';
import LottoStatisticsMapper from '@core/mappers/lotto/LottoStatisticsMapper';

const lottoStatisticsMapper: LottoStatisticsMapper = new LottoStatisticsMapper();
const lottoOddMapper: LottoOddMapper = new LottoOddMapper();

export default class LottoEventMapper extends AbstractMapper<ILottoEventDto, LottoEvent> {
    createTargetObject(dto: ILottoEventDto, key: string): LottoEvent {
        const lottoEvent = new LottoEvent();
        lottoEvent.id = parseInt(dto.lotoOfferId, 10);
        lottoEvent.lottoId = dto.lotoId;
        lottoEvent.code = dto.code;
        lottoEvent.fullName = this.extractLocalizedString(dto.name);
        lottoEvent.name = lottoEvent.fullName.split('-')[0].trim();
        lottoEvent.date = this.toDate(dto.utcDate || dto.dateTime, { assumeUtc: true });
        lottoEvent.numbersDrawn = dto.numbersToGuess;
        lottoEvent.totalNumbers = dto.numbersOff;
        lottoEvent.odds = lottoOddMapper.map(dto.odds, true);
        lottoEvent.rules = dto.rules;
        if (dto.endBet) {
            /*
                endBet is in UTC time but doesn't have that info in the string
                This is correcting that by making sure the it's in utc
            */
            const tokens = dto.endBet.split(' ');
            const endBetUtc = `${tokens[0]}T${tokens[1]}.000Z`;
            lottoEvent.endBet = this.toDate(endBetUtc) as Date;
        }
        if (!!dto.stats) {
            lottoEvent.stats = {
                statistics: lottoStatisticsMapper.map(dto.stats.statistics)
            };
        }
        if (dto.results) {
            if (typeof dto.results === 'string') {
                lottoEvent.results = dto.results.split(',');
            } else {
                lottoEvent.results = [`${dto.results}`];
            }
        }
        return lottoEvent;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/lotto/LottoEventMapper.ts